import React from "react";
import MUIDataTable from "mui-datatables";
import { api } from "./api/client";
import { CircularProgress, Box, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Tooltip } from "@mui/material";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import './App.css';
import {utils, write} from "xlsx";
import { saveAs } from 'file-saver'
import {adaptV4Theme, createTheme, ThemeProvider} from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import MalzemeListesiOnizleme from "./MalzemeListesiOnizleme";
import ExpandableRowEntry from "./ExpandableRowEntry";
import OdemeTakipRaporuChild from "./OdemeTakipRaporuChild";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";
import { buildPageParams, withServerSideOptions, makeServerTableHandler } from "./utils/serverSideTable";
import { applyFilterFacets, fetchOdemeTakipFilterOptions } from "./utils/filterFacets";
class OdemeTakipRaporu extends React.Component {
    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const yil = params.get("yil") || new Date().getFullYear().toString();
        const ay = params.get("ay") ;

        const temsilci = params.get("temsilci") || "";

        // Filtreleri constructor'da yükle (senkron)
        const savedFilters = this.loadFiltersSync();

        this.state = {
            veriler: [],
            count: 0,
            page: 0,
            rowsPerPage: 50,
            search: '',
            filters: {},
            filterOpts: {},
            yukleniyor: true,
            yil: yil ,
            ay: ay,
            temsilci: temsilci ? temsilci : '',
            mal:0,
            hizmet:0,
            notDialogAcik: false,
            secilenTeklifNo: null,
            filterList: savedFilters // Filtreleri state'te tut
        };

        this.notInputRef = React.createRef();
    }

    loadFilters = () => {
        try {
            const saved = localStorage.getItem('odemeTakipFilters');
            const filters = saved ? JSON.parse(saved) : [];
            console.log('Filtreler localStorage\'dan yüklendi:', filters);
            return filters;
        } catch (err) {
            console.error('Filtre yükleme hatası:', err);
            return [];
        }
    };

    loadFiltersSync = () => {
        try {
            const saved = localStorage.getItem('odemeTakipFilters');
            const filters = saved ? JSON.parse(saved) : [];
            console.log('Filtreler constructor\'da yüklendi:', filters);
            return filters;
        } catch (err) {
            console.error('Filtre yükleme hatası:', err);
            return [];
        }
    };

    saveFilters = (filterList) => {
        try {
            console.log('Filtreler localStorage\'a kaydediliyor:', filterList);
            localStorage.setItem('odemeTakipFilters', JSON.stringify(filterList));
        } catch (err) {
            console.error('Filtre kaydetme hatası:', err);
        }
    };

    clearFilters = () => {
        localStorage.removeItem('odemeTakipFilters');
        this.setState({ filterList: [] }, () => {
            window.location.reload();
        });
    };

    componentDidMount() {
        // localStorage filterList → serverside filters (kolon sırası sabit)
        const fl = this.state.filterList || [];
        const names = [
            null, null, "musteri", null, "temsilci",
            null, null, null, null, "para_birimi", "odendi_raw",
        ];
        const filters = {};
        names.forEach((name, i) => {
            if (!name) return;
            const vals = fl[i];
            if (vals && vals.length) {
                filters[name] = vals.length === 1 ? vals[0] : vals;
            }
        });
        this.setState({ filters }, () => {
            this.veriGetir();
            this.loadFilterOpts();
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.yil !== this.state.yil || prevState.ay !== this.state.ay) {
            this.setState({ page: 0 }, () => {
                this.veriGetir();
                this.loadFilterOpts();
            });
        }
    }

    loadFilterOpts = async () => {
        try {
            const opts = await fetchOdemeTakipFilterOptions({
                yil: this.state.yil,
                ay: this.state.ay || undefined,
            });
            this.setState({ filterOpts: opts || {} });
        } catch (e) {
            console.error("Filtre seçenekleri alınamadı", e);
        }
    };

    veriGetir = () => {
        this.setState({ yukleniyor: true });
        const pageParams = buildPageParams({
            page: this.state.page,
            rowsPerPage: this.state.rowsPerPage,
            search: this.state.search,
            filters: this.state.filters,
            sortBy: this.state.sortBy,
            sortDir: this.state.sortDir,
            extra: { yil: this.state.yil, ay: this.state.ay || undefined },
        });

        api
            .get(`/raporlar/odeme-takip`, { params: pageParams })
            .then(res => {
                try {
                    const raw = res.data;
                    const liste = Array.isArray(raw?.liste)
                        ? raw.liste
                        : Array.isArray(raw)
                          ? raw
                          : [];
                    const temiz = liste
                        .filter(d => d && typeof d === "object")
                        .map(d => ({
                            teklif_no: d?.teklif_no ?? "",
                            musteri: d?.musteri ?? "",
                            sevk_tarihi: d?.sevk_tarihi,
                            teklif_tarihi: d?.teklif_tarihi ?? "",
                            teklif_dili: d?.teklif_dili ?? "",
                            fiyat_euro: parseFloat(d?.toplam_fiyat ?? d?.toplam_tutar ?? 0) || 0,
                            para_birimi: d?.para_birimi ?? "",
                            yetkili: d?.yetkili ?? "",
                            temsilci: d?.temsilci ?? "",
                            yetkili_eposta: d?.yetkili_eposta ?? "",
                            yetkili_tel: d?.yetkili_tel ?? "",
                            odendi: d?.odendi ?? "",
                            odendi_raw: (d?.odendi === 0 || d?.odendi === false || d?.odendi === "0")
                                ? "Ödenmedi"
                                : "Ödendi",
                            odeme_notu: d?.odeme_notu ?? "",
                        }));

                    this.setState({
                        veriler: temiz,
                        count: raw?.count != null ? Number(raw.count) : temiz.length,
                        yukleniyor: false,
                        toplamlar: raw?.toplamlar || {},
                    });

                } catch (mapError) {
                    console.error("Veri map sırasında patladı:", mapError);
                    this.setState({ veriler: [], count: 0, yukleniyor: false });
                }
            })
            .catch(err => {
                console.error("Veri alınamadı:", err.message);
                this.setState({ yukleniyor: false });
            });
    };

    yilDegisti = (e) => {
        this.setState({ yil: e.target.value });
    };
    ayDegisti = (e) => {
        this.setState({ ay: e.target.value });
    };

    notDialogAc = (teklifNo, mevcutNot) => {
        console.log("Dialog açılıyor. Teklif:", teklifNo, "Mevcut not:", mevcutNot);
        this.setState({
            notDialogAcik: true,
            secilenTeklifNo: teklifNo
        }, () => {
            // Dialog açıldıktan sonra input'a değeri set et
            setTimeout(() => {
                if (this.notInputRef.current) {
                    this.notInputRef.current.value = mevcutNot || "";
                    console.log("Not input'a yazıldı:", mevcutNot);
                } else {
                    console.error("notInputRef.current yok!");
                }
            }, 100);
        });
    };

    notDialogKapat = () => {
        this.setState({
            notDialogAcik: false,
            secilenTeklifNo: null
        });
        if (this.notInputRef.current) {
            this.notInputRef.current.value = "";
        }
    };

    notKaydet = async () => {
        const { secilenTeklifNo } = this.state;
        const notMetni = this.notInputRef.current ? this.notInputRef.current.value : "";

        try {
            console.log("Gönderilen veri:", { teklif_no: secilenTeklifNo, odeme_notu: notMetni });

            const response = await api.post("/raporlar/odeme-notu", {
                teklif_no: secilenTeklifNo,
                odeme_notu: notMetni,
            });
            const result = response.data || {};
            if (result.success) {
                this.notDialogKapat();
                this.veriGetir();
            } else {
                alert("Hata: " + (result.message || "not kaydedilemedi"));
            }
        } catch (err) {
            const data = err?.response?.data;
            const msg = data?.error?.message || data?.message || data?.detail || err.message;
            alert("Hata: " + msg);
        }
    };

    normalizeParaBirimi = (paraBirimi) => {
        const normalized = String(paraBirimi || "").trim().toUpperCase();
        if (normalized === "EUR") return "EURO";
        if (normalized === "TRL") return "TL";
        return normalized || "Bilinmiyor";
    };

    paraBirimiSembol = (paraBirimi) => {
        const semboller = {
            EURO: "€",
            TL: "₺",
            USD: "$",
            GBP: "£"
        };
        return semboller[paraBirimi] || paraBirimi;
    };

    formatTutar = (tutar) =>
        Number(tutar || 0).toLocaleString("tr-TR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

    hesaplaDipToplamlar = (displayData = []) => {
        return displayData.reduce((toplamlar, row) => {
            const record = this.state.veriler[row.dataIndex];
            if (!record) return toplamlar;

            const paraBirimi = this.normalizeParaBirimi(record.para_birimi);
            toplamlar[paraBirimi] = (toplamlar[paraBirimi] || 0) + Number(record.fiyat_euro || 0);
            return toplamlar;
        }, {});
    };

    render() {
        console.log('Render - filterList:', this.state.filterList);

        const options = {
            sortOrder: { name: "sevk_tarihi", direction: "desc" },
            filter: true,
            onFilterChange: (changedColumn, filterList, type) => {
                console.log('onFilterChange:', changedColumn, filterList, type);
                this.setState({ filterList });
                this.saveFilters(filterList);
            },
            customToolbar: () => {
                return (
                    <Tooltip title="Filtreleri Temizle">
                        <IconButton onClick={this.clearFilters}>
                            <FilterListOffIcon />
                        </IconButton>
                    </Tooltip>
                );
            },
            selectableRows: 'none',
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: this.state.rowsPerPage,
            fixedHeader: true,
            //fixedSelectColumn: true,
            tableBodyHeight: '80%',
            print:false,
            download:true,
            searchOpen:false,
            draggableColumns: {
                enabled:true,
                transitionTime:400
            },
            rowStyle: {
                fontSize: 9,
            },
            downloadOptions: {
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },

            textLabels :{
                body: {
                    noMatch: "Bu tabloda hiç bir veri yok",
                    toolTip: "Sırala",
                    columnHeaderTooltip: column => `${column.label} için sırala`
                },
                selectedRows: {
                    text: "satır seçildi",
                    delete: "SiparişeEkle",
                    deleteAria: "Seçilenleri siparişe aktar",
                },
                pagination: {
                    next: "İleri",
                    previous: "Geri",
                    rowsPerPage: "Sayfadaki satır sayısı:",
                    displayRows: "/",
                },
                toolbar: {
                    search: "Ara",
                    downloadCsv: "XLSX İndir",
                    print: "Çıktı Al",
                    viewColumns: "Sütunları Göster",
                    filterTable: "Tabloyu Süz",
                },
                filter: {
                    all: "Tümünü Göster",
                    title: "Filtreler",
                    reset: "Sıfırla",
                },
                viewColumns: {
                    title: "Sütunları Göster",
                    titleAria: "Sütunları Göster/Gizle",
                },

            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const fileExtension = ".xlsx";

                console.log(values.forEach(val => console.log(val)));

                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => {
                        temp[columns[idx].name] = v;
                    });
                    result.push(temp);
                    return result;
                }, []);

                const fileName = `Ödeme Takip Listesi`;
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName + fileExtension);
                // cancel default  CSV download from table
                return false;
            },
            expandableRows: true,
            // aramanın yanında temizle butonu customSearchRender: Debounce.debounceSearchRender(500),

            renderExpandableRow: (rowData, rowMeta) => {
                return (
                    <TableRow>
                        <TableCell colSpan={kolonlar.length + 1} style={{ padding: 8 }}>
                            <OdemeTakipRaporuChild rowData={rowData} rowMeta={rowMeta} />
                        </TableCell>
                    </TableRow>
                );
            },
            customTableBodyFooterRender: ({ data }) => {
                const toplamlar = this.hesaplaDipToplamlar(data);
                const paraBirimleri = Object.keys(toplamlar).sort((a, b) => a.localeCompare(b, "tr"));

                return (
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={kolonlar.length + 1} style={{ backgroundColor: "#fff7ed", padding: 10 }}>
                                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 3, flexWrap: "wrap", fontWeight: 700 }}>
                                    <span>Dip Toplam:</span>
                                    {paraBirimleri.length > 0 ? (
                                        paraBirimleri.map(paraBirimi => (
                                            <span key={paraBirimi}>
                                                <strong style={{ color: "#f60" }}>{paraBirimi}:</strong>{" "}
                                                {this.formatTutar(toplamlar[paraBirimi])} {this.paraBirimiSembol(paraBirimi)}
                                            </span>
                                        ))
                                    ) : (
                                        <span>0,00</span>
                                    )}
                                </Box>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                );
            },
	        };
        const myTheme  = createTheme(adaptV4Theme({
            overrides: {

                MUIDataTableHead:{
                    root:{
                        lineHeight:0.5,
                        maxHeight:"10px",
                        padding:0
                    }
                },
                MUIDataTableBodyRow: {
                    root: {
                        '&:nth-child(odd)': {
                            backgroundColor: '#eee'
                        },
                        '&:nth-child(even)': {
                            backgroundColor: '#fff'
                        },
                        lineHeight: 1,
                        padding:1
                    },
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: "#e59e53 !important",
                        fontWeight: "bold",
                        padding:5
                    },
                    root: {
                        lineHeight:1
                    }
                },


            },
        }));
        const handleToggleOdendi = async (rowData) => {

            const teklifNo = rowData[0]; // 1. sütun teklif_no ise
            const mevcut = rowData[11]; // odendi kolonu index 11'de
            const yeniDeger = mevcut == 1 ? 0 : 1;

            const confirmResult = window.confirm(
                yeniDeger === 1
                    ? "Bu teklifi ÖDENDİ olarak işaretlemek istiyor musun?"
                    : "Bu teklifi ÖDENMEDİ olarak işaretlemek istiyor musun?"
            );

            if (!confirmResult) return;

            try {
                const { data } = await api.patch("/raporlar/odendi", null, {
                    params: {
                        teklif_no: teklifNo,
                        odendi: yeniDeger === 1,
                    },
                });

                if (data && data.success) {
                    this.veriGetir();
                } else {
                    alert("Hata: kayıt güncellenemedi");
                }
            } catch (err) {
                const body = err?.response?.data;
                const msg = body?.error?.message || body?.detail || body?.message;
                alert(msg ? `Hata: ${msg}` : "Sunucu hatası");
            }
        };
        function kisaltMusteriAdi(ad) {
            const kelimeler = ad.trim().split(" ");
            return kelimeler.slice(0, 3).join(" ");
        }
        const kolonlar = applyFilterFacets([

            { name: "teklif_no", label: "Teklif No",
                options: {
                    display: false,
                    filter:false
            }
            },
            {
                name: "teklif_no",
                label: "Teklif No",
                options: {
                    filter: false,
                    customBodyRender: (value, meta, updateValue) => {
                        const record = this.state.veriler[meta.currentTableData[meta.rowIndex].index];

                        if (value) {
                            return (
                                <MalzemeListesiOnizleme teklifNo={value} teklifDili={record.teklif_dili} teklifTarihi={record.teklif_tarihi} musteri={record.musteri}/>

                            );

                        }
                    },
                    customFilterListOptions: { render: v => `Teklif NO: ${v}` },
                },
            },
            { name: "musteri", label: "Müşteri",
                options: {
                    filter: true,
                    filterOptions: { fullWidth: true },
                    customBodyRender: (value, meta, updateValue) => {
                        if (value) {
                            return (kisaltMusteriAdi(value))
                        }
                    }
                }
            },
            {
                name: "sevk_tarihi", label: "Sevk Tarihi",



                options: {
                    customBodyRender: (value, meta, updateValue) => {
                        return value ? new Date(value).toLocaleDateString("tr-TR") : "";

                    },
                    filter: false,
                }

            },
            {
                name: "temsilci", label: "Temsilci",
                options: {
                    filter: true,
                    filterOptions: { fullWidth: true },
                },
            },
            { name: "yetkili", label: "Yetkili",
                options: {
                    filter: false,
                },
            },
            { name: "yetkili_tel", label: "Yetkili Tel.",
                options: {
                    filter: false,
                },
            },
            { name: "yetkili_eposta", label: "Y. Eposta",
                options: {
                filter: false,
                customBodyRender: (value, meta, updateValue) => {
                    if (value) {
                        return (
                            <a href={`mailto:${value}`} style={{ color: "#1976d2" }}>
                                {value}
                            </a>
                        );
                    }
                }
                }
            },

            {
                name: "fiyat_euro",
                label: "Fiyat",
                options: {
                    customBodyRender: (value) =>
                        value?.toLocaleString("tr-TR", { minimumFractionDigits: 2 }),
                    setCellProps: () => ({
                        style: { textAlign: "right" }   // ❗ Sadece bu kolonu sağa yaslar
                    }),

                        filter: false,

                }
            },
            {
                name: "para_birimi",
                label: "Para Birimi",
                options: {
                    filter: true,
                    filterOptions: { fullWidth: true },
                },
            },
            {
                name: "odendi_raw",
                label: "Ödeme Durumu",
                options: {
                    display: false,
                    filter: true,
                    filterType: "checkbox",
                    filterOptions: {
                        names: ["Ödenmedi", "Ödendi"],
                    },
                    sort: true
                }
            },
            {
                name: "odendi",
                label: "Ödendi",
                options: {
                    filter: false,

                    customFilterListOptions: {
                        render: v => (v == 1 ? "Ödendi" : "Ödenmedi")
                    },
                    customBodyRender: (value, tableMeta) => {
                        const checked = Number(value) === 1;
                        return (
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={checked}
                                    onChange={() => handleToggleOdendi(tableMeta.rowData)}
                                />
                                <span className="slider round"></span>
                            </label>
                        );
                    }
                },


            },
            {
                name: "odeme_notu",
                label: "Not",
                options: {
                    filter: false,
                    sort: false,

                }
            },
            {
                name: "odeme_notu",
                label: "Not",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const teklifNo = tableMeta.rowData[1]; // teklif_no ikinci sütunda
                        const mevcutNot = value || "";
                        const renk = mevcutNot ? "#1976d2" : "#ccc";

                        return (
                            <Tooltip title={mevcutNot || "Not ekle"}>
                                <IconButton
                                    size="small"
                                    onClick={() => this.notDialogAc(teklifNo, mevcutNot)}
                                    style={{ color: renk }}
                                >
                                    <NoteAddIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        );
                    }
                }
            },
        ], this.state.filterOpts);

        const kolonlarWithSavedFilters = kolonlar.map((col, idx) => ({
            ...col,
            options: {
                ...(col.options || {}),
                filterList:
                    this.state.filterList && this.state.filterList[idx]
                        ? this.state.filterList[idx]
                        : []
            }
        }));

        return (
            <Box sx={{p: 2}}>
                <p></p>


	                {this.state.yukleniyor && !this.state.veriler.length ? (
                    <Box sx={{display: "flex", justifyContent: "center", mt: 4}}>
                        <CircularProgress/>
                    </Box>
                ) : (
                    <Box sx={{ position: "relative" }}>
                        {this.state.yukleniyor && (
                            <Box sx={{
                                position: "absolute", inset: 0, zIndex: 2,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                bgcolor: "rgba(255,255,255,0.55)",
                            }}>
                                <CircularProgress size={36} />
                            </Box>
                        )}
                        <ThemeProvider theme={myTheme}>
                            <MUIDataTable
                                title={`Ödeme Takip Raporu  `}
                                data={this.state.veriler}
                                columns={enhanceColumns(kolonlarWithSavedFilters)}
                                options={withTableOptions(withServerSideOptions(options, {
                                    count: this.state.count,
                                    page: this.state.page,
                                    rowsPerPage: this.state.rowsPerPage,
                                    sortBy: this.state.sortBy,
                                    sortDir: this.state.sortDir,
                                    onServerTableChange: makeServerTableHandler(this, "veriGetir"),
                                }))}
                            />
                        </ThemeProvider>
                    </Box>
                )}

                <Dialog
                    open={this.state.notDialogAcik}
                    onClose={this.notDialogKapat}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>Ödeme Notu</DialogTitle>
                    <DialogContent>
                        <TextField
                            inputRef={this.notInputRef}
                            autoFocus
                            margin="dense"
                            label="Not"
                            type="text"
                            fullWidth
                            multiline
                            rows={10}
                            defaultValue=""
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.notDialogKapat}>İptal</Button>
                        <Button onClick={this.notKaydet} variant="contained" color="primary">
                            Kaydet
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        );
    }
}

export default OdemeTakipRaporu;
